import { Link, useLocation } from 'react-router-dom';
import { useDocumentTitle } from '../lib/useDocumentTitle';

export function NotFound() {
  useDocumentTitle('找不到頁面');
  const loc = useLocation();
  return (
    <div className="max-w-md mx-auto px-3 sm:px-4 py-6 sm:py-16">
      <div className="relative overflow-hidden rounded-2xl border border-slate-800 bg-slate-900 p-5 sm:p-6 text-center space-y-4">
        {/* Soft brand-tinted glow behind the 404 — pure CSS, no asset. */}
        <div
          aria-hidden="true"
          className="pointer-events-none absolute -top-12 left-1/2 -translate-x-1/2 h-40 w-40 rounded-full blur-3xl"
          style={{ background: 'radial-gradient(circle, rgba(124,70,243,0.35), transparent 60%)' }}
        />
        <p
          className="nx-404 relative text-6xl sm:text-7xl font-extrabold tracking-tight"
          aria-hidden="true"
        >
          404
        </p>
        <div>
          <h1 className="text-xl font-semibold">找不到這個頁面</h1>
          <p className="text-slate-400 text-sm break-all mt-2">
            <span className="text-slate-500">無法解析：</span>
            <code className="text-slate-300">{loc.pathname}</code>
          </p>
          <p className="text-slate-500 text-xs mt-1">
            可能是連結過期、複製錯誤，或這個角色 / 群組已經下架。
          </p>
        </div>
        <Link
          to="/"
          className="block w-full rounded-lg bg-violet-500 hover:bg-violet-400 active:scale-[0.98] text-white font-medium py-3 transition focus:outline-none focus:ring-2 focus:ring-violet-300 shadow-[0_8px_24px_-8px_rgba(124,70,243,0.6)]"
        >回首頁瀏覽角色</Link>
      </div>
    </div>
  );
}
